import { Calendra2, ExpectedInstallmentDate,ExpiryEffectivityDate } from '../../../common/DatePicker'; 
import { APP_TYPE_AGENCY, APP_TYPE_RENEWAL, APP_TYPE_STANDALONE, APP_TYPE_WITH_UCF, DEFAULT_INPUTFIELD_LENGTH, FIELD_TYPE, INS_TYPE_CTPL, PAYMENT_TERM_INSTALLMENT,ALLOW_ALPHABET,ALLOW_CHAR_NUM,EFFECTIVITY_EXPIRY_INTERVAL, VEHICLE_TYPE_MOTORCYCLE,VEHICLE_TYPE_MOTORCYCLE_COMMERCIAL, REGEX_EMAIL_VALIDATION, STATUS_SUCCESS, SUBTRACT_YEAR, ALLOW_MONTH, LAST_MONTH, STATUS_FIELD } from 'config/constant';
import React,{ useEffect, useState } from 'react';
import InsuranceService from 'services/InsuranceService';
import { getBrandList, getMMVList,getMMVListV1, getParentModelList, getVersionList, setNewMMVlist } from '@src/store/slices/common';
import { useSelector, useDispatch } from 'react-redux';
import ReactSelect from '@common/ReactSelect';
import {INS_TYPE_COMPREHENSIVE, WITHOUT_RULE_ENGINE} from '@src/config/constant';
import MultiSelect from '@src/common/MultiSelect';
import { updateInsuranceForm } from './FunctionList';
import { times } from 'lodash';
import { formatNPWP, nthNumber, removeCurrencyFormatting, restrictInvalidNumberKeys } from '@src/config/helper';
import CurrencyInputField from '@src/common/CurrencyInputField';
import moment from 'moment';
import { COUNTRY_CODE } from 'config/constant';
import { FUEL_TYPE, FUEL_TYPE_MAPPING, IS_HQ, POLICY_HOLDER, VEHICLE_CATEGORY, VEHICLE_CONDITION, VEHICLE_TYPE } from '@src/config/id/constant';
import { useLanguage } from '../../../../src/context/LanguageContext';
import CommonService from '@src/services/CommonService';
import * as HELPER from "../../../config/helper";
import ToggleSwitch from '@src/common/ToggleSwitch';

type EngineCapacityOption = {
    value: number;
    label: string;
};

const DynamicFormField = (props: any) => {
     /* eslint-disable @typescript-eslint/no-unused-vars */
    const [refresh, setRefresh] = useState(1) 
    const [localityList, setLocalityList] = useState([]);
   /* eslint-enable @typescript-eslint/no-unused-vars */
    const dispatch: any = useDispatch();
    const commonState = useSelector((state: any) => state.common);
    const insuranceState = useSelector((state: any) => state.insurance);
    const mmvData = (commonState.mmvList) ? commonState.mmvList : [] 
    const [typedValue, setTypedValue] = useState('');
    const [totalInstallments, setTotalInstallments] = useState(0);

    const pastSixMonths = new Date(new Date().getFullYear(), new Date().getMonth() - 6, new Date().getDate())
    const [minExpiryDate, setMinExpiryDate] = useState(moment().toDate())
    const isCountryId = COUNTRY_CODE ==='id' ? true : false;
    const {translations} = useLanguage();
    const [maxExpiryDate, setMaxExpiryDate] = useState(moment().add(SUBTRACT_YEAR.ONE, "year").endOf("year").toDate())
   
    useEffect(() => {
        //WITH UCF CASE AND RENEWAL CASE
        if (props?.apptype !== APP_TYPE_STANDALONE && props?.callfrom === 'personal_details') {
            let is_renewal = props.apptype === APP_TYPE_RENEWAL ? true : false
            let customer_details = !is_renewal ? insuranceState?.activeLoanID?.customer_details : {
                per_city: +insuranceState?.leadDetail?.per_city,
                cur_city: +insuranceState?.leadDetail?.cur_city,
                per_barangay: +insuranceState?.leadDetail?.per_barangay,
                cur_barangay: +insuranceState?.leadDetail?.cur_barangay,
            }

            // if renewal & already set then no need to update again
            if(is_renewal && insuranceState?.renewalUpdateFlag?.customerDetails) {
                return
            }

            //for fetching per barangay
            if (customer_details['per_city']) {
                let city = props?.fields?.find((e: any) => e.name === "per_city")
                let isPerSameAsCur = customer_details['per_barangay'] === customer_details['cur_barangay']
                fetchPermanentLocality({ ...city, value: { value: `${customer_details['per_city']}` } }, { per_sameas_cur: isPerSameAsCur })
            }

            //for fetching cut barangay
            if (customer_details['cur_city'] && customer_details['per_barangay'] !== customer_details['cur_barangay']) {
                let city = props?.fields?.find((e: any) => e.name === "cur_city")
                fetchCurrentLocality({ ...city, value: { value: `${customer_details['cur_city']}` } })
            }

            //populate payment term/tenure options
            if (is_renewal) {
                let payTerm = +insuranceState?.leadDetail?.payment_term
                fetchPaymentTerm()
                if(payTerm === PAYMENT_TERM_INSTALLMENT) {
                    fetchPaymentTenure(null, { payment_method: +insuranceState?.leadDetail?.payment_method, is_renewal, payment_term: +insuranceState?.leadDetail?.payment_term, payment_tenure: +insuranceState?.leadDetail?.payment_tenure })
                }
            }

        }
       // eslint-disable-next-line
    }, [props.apptype, props.callfrom, props.activeLoanID, insuranceState.leadDetail])


    useEffect(() => {
        //update total installments
        let paymentTerm = getFieldItem('payment_tenure')
        if (paymentTerm && paymentTerm?.value) {
            let label = paymentTerm?.value?.label
            let installment = label?.split(' ')?.[0] || 0 
            setTotalInstallments(installment)
        }
       // eslint-disable-next-line
    }, [])

    const isShowDynamicField = (detail: any,fieldType:any) => {

        let  policyHolder =  props?.sectionItemAll?.[0]?.blocks?.[0]?.fields?.find((field: any) => field.name === 'policy_holder')
        if(policyHolder?.value?.value === POLICY_HOLDER['COMPANY']){
            policyHolder = true;
        }else{
            policyHolder = false;
        }

        //hide payment term if not installment
        if(detail?.name === 'payment_tenure') {
            let paymentTermItem = getFieldItem('payment_term')
            let isInstallment = paymentTermItem?.value?.value === PAYMENT_TERM_INSTALLMENT ? true : false

            return isInstallment ? true : false
        }

        if (detail?.field_show) {
            //if editing quote detail page && apptype is agency
            //then hide financing to/from date
            if (props.formType === 'EDIT' &&
                (['finance_from_date', 'finance_to_date'].includes(detail.name)
                && props?.apptype === APP_TYPE_AGENCY)) {
                return false
            }

            const splitType = detail?.field_show?.split('/')

            if (splitType?.length > 1) {
                const expectedValues = splitType[1].includes('@') ? splitType[1].split('@') : [splitType[1]];
                const filterFieldItem = props?.fields?.find((each: any) => each.name === splitType[0]);
                const actualValue = String(filterFieldItem?.value?.value ?? filterFieldItem?.value);

                if (expectedValues.includes(actualValue)) {
                    return true;
                }
                else return false;
            }
        }
        if(detail &&  fieldType?.includes(detail.type)){
            return false
        }
        // for hiding input field
        if(detail &&  fieldType?.includes(detail?.name)){
            return false
        }
        //show proposed fmv if Apptype is with UCF
        if(detail?.name === 'proposed_fmv') {
            if(props.apptype === APP_TYPE_WITH_UCF) {
                detail['is_show'] = true
                return true
            }
            detail['is_show'] = false
            return false
        }

        if(detail?.name === 'expected_installment') {
            if([APP_TYPE_STANDALONE, APP_TYPE_RENEWAL].includes(props.apptype)) {
                const filterFieldItem = props?.fields?.filter((each: any) => each.name === 'payment_tenure')?.[0]
                const payTerm = props?.fields?.filter((each: any) => each.name === 'payment_term')?.[0]
                if(filterFieldItem?.value?.value && payTerm?.value?.value === PAYMENT_TERM_INSTALLMENT) {
                    return true
                }
                return false
            }
            return false
        }
        if(isCountryId && (detail?.name === 'bstk_issuance_date' || detail?.name === 'bstk_age')) {
            let vehicle_condition = getFieldItem('vehicle_condition')
            return vehicle_condition['value']['value'] === VEHICLE_CONDITION.NEW ? true : false
        }
        if(isCountryId && (detail?.name === 'marital_status' || detail?.name === 'gender' || detail?.name === 'dob' || detail?.name === 'city_birth')) {
            return policyHolder?false :true
        }
        if(isCountryId && (detail?.name === 'ktp_id' || detail?.name === 'name')) {
            if(policyHolder && detail?.name === 'ktp_id'){
                detail['label'] ='NPWP No.'
                detail['error_msg'] ="Please enter valid npwp no."
            }
            if(policyHolder && detail?.name === 'name'){
                detail['label'] ='Company Name'
                detail['error_msg'] ="Please enter valid company name"

            }
            return true 
        }

        return !!detail?.['is_show']
    }

    const showChildDependenciesIfSelected = (fieldKeys: string | string[], nextTenureValue?: any) => {
        const getFieldItemByName = (key: any) => props?.fields?.filter((item: any) => item.name === key)?.[0]

        const tenureField = getFieldItemByName('tenure')
        const currentTenureValue =
            typeof tenureField?.value === 'object' ? tenureField?.value?.value : tenureField?.value

        const keys = Array.isArray(fieldKeys) ? fieldKeys : [fieldKeys]

        keys.forEach((key: string) => {
            const sourceField = getFieldItemByName(key)
            if (!sourceField) return

            const effectiveTenureValue = key === 'tenure'
                ? (typeof nextTenureValue === 'object' ? nextTenureValue?.value : nextTenureValue)
                : currentTenureValue

            const parsedTenure = Number(effectiveTenureValue)
            if (!parsedTenure || Number.isNaN(parsedTenure) || parsedTenure <= 0) {
                return
            }

            const childDependencies = Array.isArray(sourceField?.child_depedencies) ? sourceField.child_depedencies : []
            childDependencies.forEach((childKey: any) => {
                const childField = getFieldItemByName(childKey)
                if (!childField) return
                childField['is_show'] = true
                if (props.onValueChange) props.onValueChange(childField)
            })
        })
    }

    const onValueSelect = (fieldItem: any, event: any, params?: any) => {
        //hide motorcycle for specific apptypes
        if (fieldItem.name === 'vehicle_usage') {
            let hideMotorCycleForApptype = [1, 3]
            const vehicleTypeItem = getFieldItem('vehicle_type')
            vehicleTypeItem['options'] = vehicleTypeItem?.options?.filter((e: any) => hideMotorCycleForApptype.includes(props.apptype) && (e?.value === VEHICLE_TYPE_MOTORCYCLE || e?.value === VEHICLE_TYPE_MOTORCYCLE_COMMERCIAL)? false: true);
        }

        //if vehicle type sedan & suv and user is changing vehicle usage
        //then edit vehicle type (sedan, suv) ID to be of new selected vehicle usage 
        if (fieldItem.name === 'vehicle_usage' && props.apptype === APP_TYPE_RENEWAL) {
            const isQuoteDetailPage = props?.formType === 'EDIT' ? true : false //if quote detail page then true else false
            const vehicleTypeItem = getFieldItem('vehicle_type')
            const vehicleTypeValue = vehicleTypeItem?.value
            const vehicleTypeForEdit = isQuoteDetailPage ? vehicleTypeItem?.options?.find((e: any) => e.value === vehicleTypeValue) : null
            const currVehicleUsage = vehicleTypeValue?.vehicle_usage || vehicleTypeForEdit?.vehicle_usage
            const newVehicleUsage = event?.value

            //if newly selected vehicle type and vehicle usage is not same
            //then update vehicle type according to new vehicle usage
            if (currVehicleUsage !== newVehicleUsage) {
                const vehicleTypes = vehicleTypeItem?.options
                const newVehicleType = vehicleTypes?.find((e: any) => e.label === (vehicleTypeValue?.label || vehicleTypeForEdit?.label) && e.vehicle_usage === newVehicleUsage)
                if (newVehicleType) {
                    vehicleTypeItem['value'] = { ...newVehicleType }
                    //update value of vehicle type in parent
                    if(isQuoteDetailPage) {
                        props.onValueChange(vehicleTypeItem)
                    }
                }
            }
        }

        if (fieldItem.name === 'expected_installment') {
            let { key: changedField } = params
            fieldItem['value'] = { ...fieldItem?.value, ...event }

            //reset validation error
            for (let key in event) {
                let date = event[key]['expected_installment_date']
                let amt = event[key]['expected_installment_amount']
                //clear error of date if date is present
                date && delete fieldItem['error_message']?.[key]?.['expected_installment_date']
                //clear error of amount if amount is present
                amt && delete fieldItem['error_message']?.[key]?.['expected_installment_amount']
            }

            //reset all next expected date fields
            let tenure = getFieldItem('payment_tenure')
            let totalInstallments = tenure?.value?.label?.split(' ')?.[0] || null
            if(totalInstallments) {
                let currInstallmentNum = Object.keys(event)?.[0] || null
                //reset only when date is changed
                if(currInstallmentNum && changedField === 'date') {
                    for(let idx=+currInstallmentNum+1; idx <= totalInstallments; idx++) {
                        let value = fieldItem['value']
                        let nextDateVal = new Date(value[idx]?.expected_installment_date).getTime()
                        let currDateVal = new Date(event[currInstallmentNum]?.expected_installment_date).getTime()
                        if(nextDateVal <= currDateVal) {
                            delete value[idx]?.expected_installment_date
                        }
                    }
                }
            }
            setRefresh(refresh + 1)
            return
        }

        if (fieldItem.name === 'insurance_type' && typeof params?.tenureIdx === 'number') {
            const tenureIdx = params.tenureIdx

            if (hasPreviousTloSelection(fieldItem, tenureIdx)) {
                return
            }

            const updatedSelections = [...getInsuranceTypeSelections(fieldItem, Math.max(getSelectedTenureCount(), tenureIdx + 1))]
            updatedSelections[tenureIdx] = Number(event?.value)

            syncInsuranceTypeSelections(fieldItem, updatedSelections)
            fieldItem['error_message'] = ''
            resetChildDependecies(fieldItem)

            if (props.onValueChange) {
                props.onValueChange(fieldItem)
            }

            fetch_mgf_year(fieldItem)
            return
        }

        //reset expected date on payment tenure change
        if (fieldItem.name === 'payment_tenure' && [APP_TYPE_STANDALONE, APP_TYPE_RENEWAL].includes(props.apptype)) {
            //reset validation error
            let expectedDates = getFieldItem('expected_installment')
            for (let key in expectedDates?.['error_message']) delete expectedDates?.['error_message']?.[key]
            // expectedDates['value'] = {}

            let totalInstallments = event?.label?.split(' ')?.[0] || 0
            setTotalInstallments(totalInstallments)
        }

        if (fieldItem.name === 'other_doc') {
                fieldItem.value = event.map((selected: any) => selected.value);
        }

        if (fieldItem.name === 'tenure') {
            const insuranceTypeField = getFieldItem('insurance_type')
            const nextTenure = Number(typeof event === 'object' ? event?.value : event)

            if (insuranceTypeField) {
                syncInsuranceTypeSelections(insuranceTypeField, getInsuranceTypeSelections(insuranceTypeField, nextTenure), nextTenure)
                insuranceTypeField['error_message'] = ''
            }

            const insuranceStartDateField = getFieldItem('insurance_start_date')
            if (insuranceStartDateField?.value) {
                syncDateFieldWithTenure(insuranceStartDateField.value, 'insurance_ending_date', nextTenure)
            }

            // If tenure is selected, show dependent fields (e.g. multi-year insurance type).
            showChildDependenciesIfSelected(fieldItem?.name, event)
        }

        if (fieldItem.name === 'make' && event.value === 0) {

            let modelItem = getFieldItem('model')
            modelItem['value'] = event
            modelItem['value_selected'] = event

            let versionItem = getFieldItem('version')
            versionItem['value'] = event
        } else if (fieldItem.name === 'model' && event.value === 0) {
            let versionItem = getFieldItem('version')
            versionItem['value'] = event
        }
        // reset finance_to_date"
        if(fieldItem.name === "finance_from_date"){
            let tillDateItem = getFieldItem('finance_to_date');
            if (tillDateItem) {
                tillDateItem.value = null;
            }
        }
        if(fieldItem.name === "effectivity_date"){
            fieldItem['value'] = new Date(event).toLocaleDateString();
            let expiryDateItem = getFieldItem('expiry_date');
            if (expiryDateItem) {
                expiryDateItem.value = '';
                expiryDateItem.error_message = '';
                if (props.onValueChange) props.onValueChange(expiryDateItem);
            }
            const minExpiry = moment(event).add(EFFECTIVITY_EXPIRY_INTERVAL, 'days').set({ h: 0, m: 0, s: 0 }).toDate()
            setMinExpiryDate(minExpiry);
            const maxExpiry = moment(minExpiry)
                .add(SUBTRACT_YEAR.THREE, 'year')
                .toDate();
            setMaxExpiryDate(maxExpiry);
        }
        if (fieldItem.name === "insurance_start_date") {
            syncDateFieldWithTenure(event, 'insurance_ending_date')
        }
        if (["finance_from_date", "finance_to_date"].includes(fieldItem.name)) {
            let selectedDate: any = new Date(event).toLocaleDateString();
            selectedDate = selectedDate.split('/');

            fieldItem['value'] = selectedDate[2] + '-' + selectedDate[1] + '-' + selectedDate[0];
        } else {
            fieldItem['value'] = event
        }
        fieldItem['value'] = event
        fieldItem['error_message'] = ''
        resetChildDependecies(fieldItem)

        if(fieldItem.name === "payment_method") {
            let paymentTermItem = getFieldItem('payment_term')
            let paymentMethodItem = getFieldItem('payment_method')
            let paymentTenureItem = getFieldItem('payment_tenure')


            paymentTenureItem['is_show'] = false;
            paymentTermItem.value = "";
            paymentTenureItem.value = "";
            //IF BOTH SELECTED THEN SHOW
            if(paymentTermItem.value === PAYMENT_TERM_INSTALLMENT && paymentMethodItem.value){
                paymentTenureItem['is_show'] = true;
            } else {
                paymentTenureItem['is_show'] = false;
                paymentTenureItem['value'] = ''
            }
        }

        if(fieldItem.name === "payment_term") {
            let paymentTenureItem = getFieldItem('payment_tenure')
            let paymentMethodItem = getFieldItem('payment_method')
            let paymentTermItem = getFieldItem('payment_term')

            paymentTenureItem['is_show'] = false;

            //IF BOTH SELECTED THEN SHOW

            if(paymentTermItem.value && paymentMethodItem.value){

                paymentTenureItem['is_show'] = true;
            } else {
                paymentTenureItem['value'] = ''
            }
        }
        if (props.onValueChange)
            props.onValueChange(fieldItem)

        if (fieldItem?.name === 'version' && props?.onVersionSelect) {
            props?.onVersionSelect(event)
            const vehicleType = getFieldItem('vehicle_type')
            if ([VEHICLE_TYPE_MOTORCYCLE, VEHICLE_TYPE_MOTORCYCLE_COMMERCIAL].includes(vehicleType?.value?.value)) {
                const engineCapacity = getFieldItem('engine_capacity')
                if(engineCapacity){
                    if(fieldItem?.value?.engine_capacity){
                        engineCapacity.value = engineCapacity?.options.find((e:EngineCapacityOption) => e.value === fieldItem?.value?.engine_capacity)
                    }else{
                        engineCapacity.value = "";
                    }
                }
            } else if (isCountryId) {
                const engineCapacityField = getFieldItem('engine_capacity');

                if (engineCapacityField) {
                    engineCapacityField.value = event?.engine_capacity || 0;
                    engineCapacityField.error_message = "";
                    if (props.onValueChange) props.onValueChange(engineCapacityField);
                }
            }
        }

        if(fieldItem?.name === 'plate_area') {
           // const plateArea = event?.label?.split("-")[0].trim() || "";    
            props?.onPlateAreaChange(event)
            
        }

        if(fieldItem?.name === 'vehicle_condition') {
           // const plateArea = event?.label?.split("-")[0].trim() || "";    
            props?.onVehicleConditionChange(event)
            
        }

        if(fieldItem.name === 'lead_source'){
            const leadSubSource = getFieldItem('lead_sub_source');
            leadSubSource['label'] = `${fieldItem?.value?.label || 'Marketing'} Lead Category`;
            leadSubSource['options'] = commonState.common['lead_sub_source'].filter((e:any) => +e.lead_source_id === +fieldItem?.value?.value)
            leadSubSource['value'] = "";
        }
        if (isCountryId && fieldItem.name === 'vehicle_category') {
            const vehicleType = getFieldItem('vehicle_type');
            const filteredOptions = commonState?.common?.vehicle_type?.filter(
                (e: any) => e?.category_id === event.value
            );

            vehicleType['options'] = filteredOptions
            if(event.value===VEHICLE_CATEGORY.BUS_TRUCK_PICKUP){
                const foundObject = filteredOptions.find((item:any) => item.category_id === event.value);
                vehicleType['value'] = foundObject;
                resetChildDependecies(vehicleType)
                props.onValueChange(vehicleType)
            }
        }

        switch (fieldItem?.name) {
            case 'make_year':
            case 'vehicle_usase':
            case 'version':
                break
            case 'per_city':
                fetchPermanentLocality(fieldItem)
                break
            case 'cur_city':
                fetchCurrentLocality(fieldItem)
                break
            case 'addon_detail':
                if (+event.value === 0) {
                    resetAddonList()
                }
                break
            case 'per_barangay':
                preFillPostalCode(event?.pin_code, fieldItem?.child_depedencies,fieldItem?.name);
                break;
            case 'cur_barangay':
                preFillPostalCode(event?.pin_code, fieldItem?.child_depedencies,fieldItem?.name)
                break;
            case 'insurance_type' :
                fetch_mgf_year(fieldItem)
                break;  
            case 'payment_term' :
                fetchPaymentTenure(fieldItem)
                break; 
            case 'payment_method' :
                fetchPaymentTerm(fieldItem)
                break;  
            case 'per_region':  
                fetchPermanentCity(fieldItem)
                break
            case 'cur_region':  
                 fetchCurrentCity(fieldItem)
                break   
            default:
                break
        }

        if (isSameAsSelected()) {
            prefillSameAsAddress(fieldItem)
        }

        if(fieldItem.name === "car_under_finance") {
            const curfieldData = getFieldItem('financier')
            const curfieldDataFinancierName = getFieldItem('financier_name')
            if (curfieldData) {
                
                if(fieldItem.value?.value === 1){

                    if(curfieldData['value']?.value>0 || curfieldData['value']>0){
                        
                        curfieldDataFinancierName['is_show'] = false
                        curfieldDataFinancierName['value'] = ""
                        if (curfieldDataFinancierName && props.onValueChange) props.onValueChange(curfieldDataFinancierName);
                    }else if(curfieldData['value']===0 || curfieldData['value']?.value===0){
                        curfieldDataFinancierName['is_show'] = true
                        if (curfieldDataFinancierName && props.onValueChange) props.onValueChange(curfieldDataFinancierName);
                        
                    }else{
                        curfieldData['is_required'] = true

                        if (curfieldData && props.onValueChange) props.onValueChange(curfieldData);
                    }
                }else{
                    if(curfieldDataFinancierName){

                        curfieldDataFinancierName['is_show'] = false
                        curfieldDataFinancierName['value'] = ""
                        curfieldDataFinancierName['error'] = ""
                    }
                    if (curfieldDataFinancierName && props.onValueChange) props.onValueChange(curfieldDataFinancierName);
                    curfieldData['value'] = ""
                    curfieldData['error'] = ""

                    if (curfieldData && props.onValueChange) props.onValueChange(curfieldData);

                }
            
            }

        }
        if(isCountryId &&  fieldItem.name === "bstk_issuance_date") {
            const bstkAge = getDayDiffFromToday(event);
            const fieldData = getFieldItem('bstk_age');
            if (fieldData) {
                fieldData['value'] = bstkAge
                fieldData['error_message'] = ''
                if (props.onValueChange) props.onValueChange(fieldData)
            }
        }
        if(isCountryId &&  fieldItem.name === "user_id") {
            const role_id = event.role_id;
            const fieldData = getFieldItem('role_id');
            if (fieldData) {
                fieldData['value'] = role_id
                fieldData['error_message'] = ''
                if (props.onValueChange) props.onValueChange(fieldData)
            }
        }
    }

    const  getDayDiffFromToday = (inputDate: Date): number => {
        const today = new Date();
        // Only date part compare karna (time ignore)
        const todayOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        const givenDate = new Date(inputDate.getFullYear(), inputDate.getMonth(), inputDate.getDate());
        const diffTime = Math.abs(todayOnly.getTime() - givenDate.getTime());
        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
        // Today ko 1 count karne ke liye +1
        return diffDays + 1;
    }

    const preFillPostalCode = (pinCode: any, child_depedencies: any,fieldName:any) => {
        const fieldData = getFieldItem(child_depedencies[0]);
        if (fieldData) {
            fieldData['value'] = pinCode + ''
            fieldData['error_message'] = ''
            if (props.onValueChange) props.onValueChange(fieldData)
        }
 
        if ((isSameAsSelected() || fieldName ==='cur_barangay') && !isCountryId) {
            const curfieldData = getFieldItem('cur_postal_code')
            if (curfieldData) {
                curfieldData['value'] = pinCode + ''
                curfieldData['error_message'] = ''
                if (props.onValueChange) props.onValueChange(curfieldData)
            }
        }
    }
    const resetAddonList = () => {
        let addonFieldItem = getFieldItem('addon_detail')
        if (addonFieldItem) {
            addonFieldItem['original_list'] = []
        }
        if (props?.resetAddonList) props.resetAddonList()
    }

    const fetchPermanentLocality = async (fieldItem?: any, params?: any) => {
        let response = null;
        if(isCountryId){
            response = await CommonService.getLocalityList({ city: [fieldItem.value.value] })

        }else{
            response = await InsuranceService.getlocalityByCity({ city: [fieldItem.value.value] })
        }
        if (response?.status === STATUS_SUCCESS) {
            if (response?.data?.data) {
                setLocalityList(response.data.data)
            }
        }
        let perBarangayField = getFieldItem('per_barangay')
        let bothBaragay = [perBarangayField]
        if (perBarangayField) {
            perBarangayField['options'] = response?.data?.data
        }

        if (isSameAsSelected() || params?.per_sameas_cur) {
            let perBarangayField = getFieldItem('cur_barangay')
            if (perBarangayField) {
                perBarangayField['options'] =response?.data?.data
            }
            bothBaragay.push(perBarangayField)
        }
        updateBarangay(bothBaragay, response, 'per_barangay')
    }

    const fetchCurrentLocality = async (fieldItem?: any) => {
        //fetch by city id =  fieldItem.value.value
        let perBarangayField = getFieldItem('cur_barangay')
        if (perBarangayField) {
            let response = null
            if(isCountryId){
                response = await await CommonService.getLocalityList({ city: [fieldItem.value.value] })
            }else{
                response = await InsuranceService.getlocalityByCity({ city: [fieldItem.value.value] })
            }
            if (response?.status === STATUS_SUCCESS) {
                if (response?.data?.data) {
                    perBarangayField['options'] = response.data.data;
                    setRefresh((prev) => prev+1);
                    updateBarangay([perBarangayField], response, 'cur_barangay')
                }
            }
        }
    }

    const isSameAsSelected = () => {
        let sameAsField = props?.fields?.filter((item: any) => item.name === 'per_sameas_cur')?.[0]
        if (sameAsField)
            return sameAsField?.value
        return false
    }

    const prefillSameAsAddress = (fieldItem: any) => {
        if (fieldItem.name.includes('per_')) {
            const keyName = fieldItem?.name?.replace('per_', 'cur_');
            let fields = props?.fields?.filter((item: any) => item.name === keyName)  
            if (fields.length) {
                if (isSameAsSelected()) {
                    fields[0]['is_enable'] = false
                } else {
                    fields[0]['is_enable'] = true
                }
                if(fields[0].name === "cur_postal_code"){
                    fields[0]['is_enable'] = false
                }
                if(!isSameAsSelected() && fields[0].name === "cur_postal_code"){
                    fields[0]['is_enable'] = true
                }
                fields[0].value = fieldItem.value
                fields[0].error_message = ""

            }
        }
    }

    const checkValidationId = (fieldItem: any, policyHolder: boolean = false) => {        
        const { name, value } = fieldItem;        

        const trimmedValue = value.trim();
        
        fieldItem.error_message = '';        

        switch (name) {
            case 'ktp_id':
                if (policyHolder) {
                    const npwpFormat = /^\d{2}\.\d{3}\.\d{3}\.\d{1}-\d{3}\.\d{3}$/;
                    if (!npwpFormat.test(trimmedValue)) {
                        fieldItem.error_message = translations.RuleEngineAgency?.NPWP_format_error_msg || translations.commonMsg?.loading
                    }
                } else {
                    if (!/^\d{16}$/.test(trimmedValue)) {
                        fieldItem.error_message = translations.RuleEngineAgency?.KTP_id_length_msg ||  translations.commonMsg?.loading
                    }
                }
                break;

            case 'phone':
                if (!/^8\d{7,12}$/.test(trimmedValue)) {
                    fieldItem.error_message = translations.RuleEngineAgency?.Agency_mobile_error_msg || translations.commonMsg?.loading
                }
                break;

            case 'email':
                if (!REGEX_EMAIL_VALIDATION.test(trimmedValue)) {
                    fieldItem.error_message = translations.RuleEngineAgency?.Email_error_msg || translations.commonMsg?.loading
                }
                break;

            case 'cur_rt':
            case 'per_rt':
                // if (!/^\d{3}$/.test(trimmedValue)) {
                //     fieldItem.error_message = translations.RuleEngineAgency?.RT_error_msg || translations.commonMsg?.loading
                // }
                break;

            case 'cur_rw':
            case 'per_rw':
                // if (!/^\d{3}$/.test(trimmedValue)) {
                //     fieldItem.error_message = translations.RuleEngineAgency?.RW_error_msg || translations.commonMsg?.loading
                // }
                break;

            case 'plate_number': {
                // const vehicleConditionItem = getFieldItem('vehicle_condition') || props?.sectionItemAll?.[0]?.blocks?.[0]?.fields?.find((f: any) => f.name === 'vehicle_condition');
                // const vehicleConditionValueRaw = typeof vehicleConditionItem?.value === 'object' ? vehicleConditionItem?.value?.value : vehicleConditionItem?.value;
                // const vehicleConditionValue = vehicleConditionValueRaw ?? insuranceState?.createInsurance?.vehicle_condition ?? insuranceState?.leadDetail?.vehicle_condition;
                const plateValue = trimmedValue.toUpperCase();
                // Old/Used vehicle: enforce format
                // if (+vehicleConditionValue === VEHICLE_CONDITION.USED) {
                //     if (!/^[A-Z]{1,2}\s?\d+(?:\s?[A-Za-z]+)?$/.test(plateValue)) {
                //         fieldItem.error_message = translations.RuleEngineAgency?.PLATE_ERROR_MSG || translations.commonMsg?.loading;
                //     }
                // }
                // New vehicle: just require non-empty
                // if (+vehicleConditionValue === VEHICLE_CONDITION.NEW) {
                //     if (!plateValue) {
                //         fieldItem.error_message = translations.RuleEngineAgency?.PLATE_ERROR_MSG || translations.commonMsg?.loading;
                //     }
                // }
                if (!plateValue) {
                    fieldItem.error_message = translations.RuleEngineAgency?.PLATE_ERROR_MSG || translations.commonMsg?.loading;
                }
                break;
            }

            case 'acc_price':
            case 'car_fmv':
              if(fieldItem.name === "acc_price"){
                const carFmv = getFieldItem('car_fmv')
                if(carFmv.value){
                    const TenPercentageOfCarfmv = (carFmv.value * 0.1)
                    if(fieldItem.value > TenPercentageOfCarfmv ){
                        fieldItem.error_message = translations?.CREATE_APPLICATION?.ACC_PRICE_ERR                   
                    }else{
                        carFmv.error_message =''
                    }
                }
              }
              else if(fieldItem.name === "car_fmv"){
                const acc_price = getFieldItem('acc_price')
                if(fieldItem.value){
                    const TenPercentageOfCarfmv = (fieldItem.value * 0.1)
                    if(acc_price.value > TenPercentageOfCarfmv ){
                        fieldItem.error_message = translations?.CREATE_APPLICATION?.ACC_PRICE_ERR                  
                    }else{
                        acc_price.error_message =''
                    }
                }
              }
               
            break;

            case 'alt_phone':
                if (trimmedValue && !/^8\d{7,12}$/.test(trimmedValue)) {
                    fieldItem.error_message = translations.RuleEngineAgency?.Agency_mobile_error_msg || translations.commonMsg?.loading
                } else {
                    fieldItem.error_message = ""
                }
                break;

            default:
                break;
        }

        if (name === "phone" || name === "alt_phone") {
            const phone = getFieldItem("phone")?.value?.trim() ?? "";
            const altPhone = getFieldItem("alt_phone")?.value?.trim() ?? "";
            if (phone && altPhone && phone === altPhone) {
                fieldItem.error_message = translations.RuleEngineAgency?.PHONE_SHOULD_NOT_MATCH || translations.commonMsg?.loading
            }
        }

        const isValid = !fieldItem.error_message;
        return isValid;
    }


      const onChangeText = (fieldItem: any, text: any) => {
        if (isCountryId) {
            let policyHolder = props?.sectionItemAll?.[0]?.blocks?.[0]?.fields?.find((field: any) => field.name === 'policy_holder')
            policyHolder = policyHolder?.value?.value === POLICY_HOLDER['COMPANY'];

            if (["ktp_id", "phone", "email", "cur_rt", "per_rt", "cur_rw", "per_rw", "plate_number","acc_price","car_fmv", 'alt_phone'].includes(fieldItem.name)) {

                if (policyHolder && fieldItem.name === "ktp_id") {
                    const previousValue = fieldItem?.value || '';
                    // If the new value's length is shorter than the previous value's length (backspace), skip formatting
                    fieldItem['value'] = (text.length < previousValue.length) ? fieldItem['value'] = text : formatNPWP(text);
                }else if (fieldItem.name === "plate_number") {
                    const platePrefix = (props?.plateArea || '').toUpperCase().trim().split(/\s+/)[0] || '';
                    if (platePrefix) {
                        const normalized = String(text ?? '').toUpperCase().replace(/^\s+/, '');
                        const prefixWithSpace = `${platePrefix} `;
                        let suffix = '';

                        if (normalized.startsWith(prefixWithSpace)) {
                            suffix = normalized.slice(prefixWithSpace.length);
                        } else if (normalized.startsWith(platePrefix)) {
                            suffix = normalized.slice(platePrefix.length);
                        } else if (normalized.length < platePrefix.length) {
                            // user is deleting into the prefix; keep suffix empty
                            suffix = '';
                        } else {
                            // user pasted/typed without prefix; treat entire input as suffix
                            suffix = normalized;
                        }

                        suffix = suffix.replace(/\s+/g, '');
                        fieldItem['value'] = suffix ? `${platePrefix} ${suffix}` : platePrefix;
                    } else {
                        fieldItem['value'] = String(text ?? '').replace(/\s+/g, '');
                    }
                } else {
                    if (fieldItem.name !== 'ktp_id' && !['cur_rt','cur_rw','per_rt','per_rw'].includes(fieldItem.name)) {
                        fieldItem['value'] = text;
                    }
                }

                if(!policyHolder && fieldItem.name === "ktp_id" && text?.length > 16){
                    return
                }
                else if(['cur_rt','cur_rw','per_rt','per_rw'].includes(fieldItem.name) && text?.length > 3){
                    return
                } else if(['cur_rt','cur_rw','per_rt','per_rw'].includes(fieldItem.name) || (!policyHolder && fieldItem.name === "ktp_id")){
                    fieldItem['value'] = text;
                }

                if (isSameAsSelected()) {
                    prefillSameAsAddress(fieldItem)
                }

                const isValid = checkValidationId(fieldItem, policyHolder); 
                props.setIsDetailValid(isValid);

                if (['make_name', 'model_name', 'version_name'].includes(fieldItem.name)) {
                    setRefresh((prev) => prev + 1);
                } else {
                    resetChildDependecies(fieldItem);
                }
                if (props.onValueChange) props.onValueChange(fieldItem)
                return;
            }
        }

        if (fieldItem?.name === "referrer_name") {
            const isValid = ALLOW_ALPHABET.test(text);
            if (!isValid && text) {
                return true;
            }
        }
        if(fieldItem?.name === "emp_code"){
            // Allow only alphabets, numbers, and spaces
            const isValid = ALLOW_CHAR_NUM.test(text);
            if (!isValid && text) {
                return false;
            }
        }
        let errorMessage = '';
        //number validation for input fields 
        if((['per_postal_code','cur_postal_code'].includes(fieldItem.name))){
            if(text.length>5){
                return true;
            }else if(text.length<5){
                const postalCodeRegex = /^\d{5}$/;
                if(!postalCodeRegex.test(text)){
                    const postalErrorKey = fieldItem.name === 'per_postal_code' ? 'PERMANENT_POSTAL_ERROR' : 'CURRENT_POSTAL_CODE';
                    const postalError = translations?.Insurance?.[postalErrorKey] || translations?.Insurance?.POSTAL_ERROR;
                    errorMessage = postalError
                }else{
                    errorMessage = '';
                }
                
            }
        }
        if (fieldItem && fieldItem.type !== 'tb') {
            if (text) {
                const regex = /^[0-9]+(\.[0-9]{0,2})?$/;             
               if (!regex.test(text)){
                return
               }
            }
        } 
        if(fieldItem.label === 'Customer Name'){
            if(!text || (text && !text.trim())){
                fieldItem['value'] = ''; 
            }
        } 
        fieldItem['value'] = text;
        fieldItem['error_message'] = errorMessage;
        if (isSameAsSelected()) {
            prefillSameAsAddress(fieldItem)
        }
        if(['make_name','model_name','version_name'].includes(fieldItem.name)){
            setRefresh((prev) => prev+1);
        }else{
            resetChildDependecies(fieldItem);
        } 
        if (props.onValueChange) props.onValueChange(fieldItem)

    }

	    const resetChildDependecies = (fieldItem: any) => {
	        let childDependencies = fieldItem?.child_depedencies || [];
	        if (fieldItem.name === 'vehicle_usage') {
	            childDependencies.push('vehicle_type');
	        }
        
        if (!isCountryId && fieldItem.name === 'vehicle_type') {
            fetchMMV();
            childDependencies = [...childDependencies, 'make', 'model', 'version', 'engine_capacity'];
            
        }

	        if(isCountryId){
	            let vehicleType = getFieldItem('vehicle_type')?.value
	            const vehicleCategoryId = getFieldItem('vehicle_category')?.value?.value
	            const vehicleTypeId = Array.isArray(vehicleType) ? vehicleType?.[0]?.value : vehicleType?.value
	            const fuelType = [VEHICLE_TYPE.EV, VEHICLE_TYPE.HYBRID].includes(vehicleTypeId)
	                ? FUEL_TYPE_MAPPING[String(vehicleTypeId)]
	                : undefined
	            const categoryId = Array.isArray(vehicleType) ? vehicleType?.[0]?.category_id : vehicleType?.category_id

	            if(fieldItem.name === 'vehicle_category' && vehicleCategoryId===VEHICLE_CATEGORY.NON_BUS_NON_TRUCK){
	                dispatch(setNewMMVlist({make:[],model:[],version:[]}));
	               childDependencies = [...childDependencies, 'make', 'model', 'version'];
	            }
            
            if(Array.isArray(vehicleType) && vehicleCategoryId===VEHICLE_CATEGORY.BUS_TRUCK_PICKUP ){
                vehicleType = vehicleType[0]
            }

	            if(fieldItem.name === 'vehicle_type'){
	                const brandSig = `${categoryId || ""}|${fuelType || ""}`
	                const hasMakeList = Array.isArray(commonState?.newMMVlist?.make) && commonState?.newMMVlist?.make?.length > 0
		                if(commonState?.newMMVlist?.brand_sig !== brandSig || !hasMakeList){
		                    props.setLoading(true) 
		                    dispatch(setNewMMVlist({brand_sig: brandSig, category_id: categoryId, make_id: null, model_id: null, model_sig: null, version_sig: null, make: [], model: [], version: []}))
		                    const brandPayload:any = {category_id:vehicleType?.category_id}
		                    const vehicle_type_id = vehicleType?.value
		                    if(vehicle_type_id === VEHICLE_TYPE.EV) brandPayload['fuel_type'] = FUEL_TYPE_MAPPING[VEHICLE_TYPE.EV]
		                    if(vehicle_type_id === VEHICLE_TYPE.HYBRID) brandPayload['fuel_type'] = FUEL_TYPE_MAPPING[VEHICLE_TYPE.HYBRID]
	                    dispatch(getBrandList(brandPayload)).then((response: any) => {
	                        props.setLoading(false) 
	                    })
	                    childDependencies = [...childDependencies, 'make', 'model', 'version'];
	                }
	            }
	            if(fieldItem.name === 'make'){
	                const makeId = fieldItem?.value?.value
	                const modelSig = `${categoryId || ""}|${fuelType || ""}|${makeId || ""}`
	                const hasModelList = Array.isArray(commonState?.newMMVlist?.model) && commonState?.newMMVlist?.model?.length > 0
		                if(commonState?.newMMVlist?.model_sig !== modelSig || !hasModelList){
		                    props.setLoading(true) 
		                    dispatch(setNewMMVlist({make_id: makeId, model_id: null, model_sig: modelSig, version_sig: null, model: [], version: []}))
		                    const modelPayload:any = {category_id:vehicleType?.category_id,make:makeId}
		                    const vehicle_type_id = vehicleType?.value
		                    if(vehicle_type_id === VEHICLE_TYPE.EV) modelPayload['fuel_type'] = FUEL_TYPE_MAPPING[VEHICLE_TYPE.EV]
		                    if(vehicle_type_id === VEHICLE_TYPE.HYBRID) modelPayload['fuel_type'] = FUEL_TYPE_MAPPING[VEHICLE_TYPE.HYBRID]
	                    dispatch(getParentModelList(modelPayload)).then((response: any) => {
	                        props.setLoading(false) 
	                    })
	                }
	            }
		            if(fieldItem.name === 'model'){
		                const modelId = fieldItem?.value?.value
		                const make = getFieldItem('make')?.value
		                const versionSig = `${categoryId || ""}|${fuelType || ""}|${make?.value || ""}|${modelId || ""}`
		                const hasVersionList = Array.isArray(commonState?.newMMVlist?.version) && commonState?.newMMVlist?.version?.length > 0
		                if(commonState?.newMMVlist?.version_sig !== versionSig || !hasVersionList){
		                    props.setLoading(true) 
		                    dispatch(setNewMMVlist({model_id: modelId, version_sig: versionSig}))
		                    const versionPayload:any = {
		                        category_id:vehicleType?.category_id,
		                        make:make?.value,
	                        model:modelId
	                    }
	                    const vehicle_type_id = vehicleType?.value
	                    if(vehicle_type_id === VEHICLE_TYPE.EV) versionPayload['fuel_type'] = FUEL_TYPE_MAPPING[VEHICLE_TYPE.EV]
	                    if(vehicle_type_id === VEHICLE_TYPE.HYBRID) versionPayload['fuel_type'] = FUEL_TYPE_MAPPING[VEHICLE_TYPE.HYBRID]
	                    dispatch(getVersionList(
	                        versionPayload
	                    )).then((response: any) => {
                        props.setLoading(false) 
                    })
                }
            }
        }
        
        if (props.apptype === APP_TYPE_WITH_UCF) {
            childDependencies = childDependencies?.filter((e: any) => ['addon_detail', 'vehicle_type'].includes(e))
        }

        //for renewal apptype do not reset fields on selection (only allow reset of below child fields)
        if(props.apptype === APP_TYPE_RENEWAL && !['per_region', 'cur_region', 'per_city', 'cur_city'].includes(fieldItem.name)) childDependencies = []

        if(isCountryId && ['cur_region', 'cur_city'].includes(fieldItem.name)){
            if(fieldItem.name === 'cur_region'){
                childDependencies = ['cur_city','cur_barangay']
            }else if(fieldItem.name === 'cur_city'){
                childDependencies = ['cur_barangay']
            }
        }

        // eslint-disable-next-line
        childDependencies.map((key: any) => {
            if (fieldItem.name === 'tenure' && key === 'insurance_type') return

            const fieldData = props?.fields?.filter((fieldData: any) => fieldData.name === key)?.[0]
            if (fieldData) {
                fieldData['error'] = ''
                fieldData['value'] = ''
                if (fieldData.name === "addon_detail") {

                    fieldData['selected_addon'] = []
                    fieldData['original_list'] = []
                    if (props?.resetAddonList) props.resetAddonList()
                }
            }
        })

        setRefresh((prev) => prev+1);
    }

    const getFieldItem = (key: any) => {
        let filterItem = props?.fields?.filter((item: any) => item.name === key)?.[0]
        return filterItem
    }

    const getSelectedTenureCount = () => {
        const tenureField = getFieldItem('tenure')
        const tenureValue = typeof tenureField?.value === 'object' ? tenureField?.value?.value : tenureField?.value
        const parsedTenure = Number(tenureValue)
        return Number.isNaN(parsedTenure) || parsedTenure <= 0 ? 0 : parsedTenure
    }

    const getInsuranceTypeOption = (fieldItem: any, optionValue: any) => {
        return (fieldItem?.options || []).find((option: any) => Number(option?.value) === Number(optionValue))
    }

    const sanitizeInsuranceTypeSelections = (values: any[], selectedTenure = getSelectedTenureCount()) => {
        const totalYears = Math.max(Number(selectedTenure) || 0, 0)
        let hasPreviousTlo = false

        return Array.from({ length: totalYears }, (_, idx: number) => {
            if (hasPreviousTlo) {
                return INS_TYPE_CTPL
            }

            const normalizedValue = Number(values?.[idx])

            if (normalizedValue === INS_TYPE_CTPL) {
                hasPreviousTlo = true
                return INS_TYPE_CTPL
            }

            if (normalizedValue === INS_TYPE_COMPREHENSIVE) {
                return INS_TYPE_COMPREHENSIVE
            }

            return ''
        })
    }

    const getInsuranceTypeSelections = (fieldItem: any, selectedTenure = getSelectedTenureCount()) => {
        const selectedValues = Array.isArray(fieldItem?.multi_year_value)
            ? fieldItem.multi_year_value
            : [typeof fieldItem?.value === 'object' ? fieldItem?.value?.value : fieldItem?.value]

        return sanitizeInsuranceTypeSelections(selectedValues, selectedTenure)
    }

    const hasPreviousTloSelection = (fieldItem: any, tenureIdx: number) => {
        return getInsuranceTypeSelections(fieldItem).slice(0, tenureIdx).some((value: any) => Number(value) === INS_TYPE_CTPL)
    }

    const syncInsuranceTypeSelections = (fieldItem: any, selections: any[], selectedTenure = getSelectedTenureCount()) => {
        const sanitizedSelections = sanitizeInsuranceTypeSelections(selections, selectedTenure)
        const firstSelectedValue = sanitizedSelections.find((value: any) => value !== '' && value !== null && value !== undefined)

        fieldItem['multi_year_value'] = sanitizedSelections
        fieldItem['value'] = getInsuranceTypeOption(fieldItem, firstSelectedValue) || ''

        return sanitizedSelections
    }

    const syncDateFieldWithTenure = (startDateValue: any, endFieldName: string, selectedTenure = getSelectedTenureCount()) => {
        const parsedStartDate = moment(startDateValue)
        const tenureYears = Number(selectedTenure)
        const endDateField = getFieldItem(endFieldName)

        if (!parsedStartDate.isValid() || !endDateField) {
            return
        }

        if (!tenureYears || tenureYears <= 0) {
            endDateField['value'] = ''
            endDateField['error_message'] = ''

            if (props.onValueChange) {
                props.onValueChange(endDateField)
            }
            return
        }

        endDateField['value'] = parsedStartDate.clone().add(tenureYears, 'year').toDate()
        endDateField['error_message'] = ''

        if (props.onValueChange) {
            props.onValueChange(endDateField)
        }
    }

    const getOptionList = (fieldItem: any) => {
        if(fieldItem?.name === "tenure"){
            return (commonState?.common?.tenure_year || []).map((option: any) => {
                const tenureValue = typeof option?.value === 'object' ? option?.value?.value : option?.value;
                const parsedTenure = Number(tenureValue);
                if (Number.isNaN(parsedTenure)) return option;
                return {
                    ...option,
                    value: parsedTenure,
                    label: `${parsedTenure} Year`
                };
            })
        }
        let vehicleTypeItem = getFieldItem('vehicle_type') 
        let vehicleCategoryId = vehicleTypeItem?.value?.category_id;

        let mmvDataRecord: any = mmvData?.[vehicleCategoryId] || {};
        if(isCountryId) mmvDataRecord = mmvData
        if (fieldItem.name === "make") {
            return isCountryId ? commonState?.newMMVlist?.make || [] : mmvDataRecord?.make
        } else if (fieldItem.name === "model") {
            let makeItem = getFieldItem('make')
            if(isCountryId){
                return commonState?.newMMVlist?.model || []
            }else{
                let value  = typeof makeItem?.value ==='object' ? makeItem?.value?.value: makeItem?.value;
                let modelList = mmvDataRecord?.model?.filter((modelItem: any) => modelItem.make === value || modelItem.value === 0)

                return modelList || []
            }
        } else if (fieldItem.name === 'version') {
            // let makeItem = getFieldItem('make')
            let modelItem = getFieldItem('model')
            if (modelItem) {
                if(isCountryId){
                    return commonState?.newMMVlist?.version || []
                }else{
                  
                    let value  = typeof modelItem?.value ==='object' ? modelItem?.value?.value: modelItem?.value;
                    let modelList = mmvDataRecord?.version?.filter((versionItem: any) => versionItem.model == value || versionItem.value == 0)   // eslint-disable-line
    
                    return modelList || []
                }
            }
        } else if (fieldItem.name === 'addon_detail') {
            // let makeItem = getFieldItem('make')
            return [{ value: 1, label: 'Yes' }, { value: 0, label: 'No' }]
        } else if (fieldItem.name === 'per_region' || fieldItem.name === 'cur_region') {
            let tempList: any = []
            props?.stateCityList?.forEach((item: any) => {
                let param = {  label: item.label, value: item.value }
                tempList.push(param)
            })
            return tempList
        } else if (fieldItem.name === 'per_city') {
            let regionItem = getFieldItem('per_region');
            let value  = typeof regionItem?.value ==='object' ? regionItem?.value?.value: regionItem?.value;
            let cityList = props?.stateCityList?.filter((item: any) => item.id === value)?.[0]?.['city_list'];
            let tempList: any = []
            cityList?.forEach((item: any) => {
                let param = { label: item.value, value: item.id }
                tempList.push(param)
            })
            return tempList
        } else if (fieldItem.name === 'cur_city') {
            let regionItem = getFieldItem('cur_region');
            let value  = typeof regionItem?.value ==='object' ? regionItem?.value?.value: regionItem?.value;
            let cityList = props?.stateCityList?.filter((item: any) => item.id === value)?.[0]?.['city_list'];
            let tempList: any = []
            cityList?.forEach((item: any) => {
                let param = { label: item.value, value: item.id }
                tempList.push(param)
            })
            return tempList
        } else if (fieldItem.name === 'vehicle_type' && !isCountryId) {
          
            let vehicleUsaseItem = getFieldItem('vehicle_usage')
            if (vehicleUsaseItem) {
                let value  = typeof vehicleUsaseItem?.value ==='object' ? vehicleUsaseItem?.value?.value: vehicleUsaseItem?.value;
                let tempOptionList = fieldItem?.options?.filter((optionItem: any) => optionItem[vehicleUsaseItem.name] == value)   // eslint-disable-line
                return tempOptionList || []
            }
            return []
        } else if (fieldItem.name === 'vehicle_usage') {
            let tempOptionList:any = fieldItem?.options

            //IN CASE OF AGENCY SHOW VALID VEHICLE TYPE
            if(props.applicationType === APP_TYPE_AGENCY){
                let getAgencyVehicle = props?.agencyList?.find((elm:any)=> elm.value === insuranceState?.leadDetail?.agency_id)
                tempOptionList = tempOptionList?.filter((el:any)=> getAgencyVehicle?.vehicle_classification?.vehicle_usage.includes(el.value))
            }

            return tempOptionList || []
        }
        else if (fieldItem.name === 'city_birth') {
            return commonState.city
        }else if(fieldItem.name === "vehicle_type" && isCountryId){
           let vehicleCategory = getFieldItem('vehicle_category')
           if(!vehicleCategory?.value) return [];
           return commonState?.common?.vehicle_type?.filter((e: any) => e.category_id === vehicleCategory?.value?.value)
        } 
        else if(fieldItem?.name === 'insurer' && fieldItem?.type === 'dd'){
            let insurerList = commonState?.common?.insurer_list || [];            
            return insurerList;
        }
        else if(fieldItem.name === "insurer_branch_id" && isCountryId){
            const insurerBranch:Record<string,any>[]=
            commonState?.common?.branch_name?.filter((e: any) => e.insurer_id === props?.extraField?.insurer_id && e.status===STATUS_FIELD.ACTIVE);
            return insurerBranch
        } 
        else {
            return fieldItem.options || []
        }
    }

    const fetchMMV = async (isfetch=false) => {
        let vehicleUsaseItem = getFieldItem('vehicle_usage') 
        let vehicleTypeItem = getFieldItem('vehicle_type') 
        if (vehicleUsaseItem?.value) { 
            let vehicle_usage = (typeof vehicleUsaseItem.value ==="object")? vehicleUsaseItem.value.value:vehicleUsaseItem.value; 
            let vehicle_type = (typeof vehicleTypeItem.value ==="object")? vehicleTypeItem.value.value:vehicleTypeItem.value; 
            let params:any = { rule_engine: props.applicationType, vehicle_usage, apptype: props.apptype, vehicle_type, category_id: vehicleTypeItem?.value?.category_id  }
            if (!(commonState?.mmvList?.[params['category_id']] && Object?.keys(commonState?.mmvList?.[params['category_id']])?.length) || isfetch) {
                props.setLoading(true)
                if(isCountryId){
                    delete params?.rule_engine;
                    delete params?.apptype;
                    delete params?.category_id
                    if(params?.vehicle_type === VEHICLE_TYPE.EV){
                        params['fuel_type'] = FUEL_TYPE.EV
                    }
                     if(params?.vehicle_type === VEHICLE_TYPE.HYBRID){
                        params['fuel_type'] = FUEL_TYPE.HYBRID
                    }
                    dispatch(getMMVListV1(params)).then((response: any) => {
                        props.setLoading(false) 
                    })
                }else{
                    dispatch(getMMVList(params)).then((response: any) => {
                       props.setLoading(false) 
                    })
                }
            }
        }
    }

    const onChangeCheckbox = (fieldItem?: any) => {
        fieldItem['value'] = !fieldItem.value
        setRefresh((prev) => prev+1);
        if (fieldItem?.name === 'per_sameas_cur') {
            setPrefillDataOnCheckboxPress()
        }
    }
    const setPrefillDataOnCheckboxPress = () => {
        props?.fields?.forEach((fieldItem: any) => {
            prefillSameAsAddress(fieldItem)
        })
    }

    const getFieldValue = (fieldItem: any) => {
        if (fieldItem.name === "total_fmv") {
            let carFMVItem = getFieldItem('car_fmv')
            let accPriceItem = getFieldItem('acc_price')
            let vehicleType = getFieldItem('vehicle_type')
            let totalValue = 0
            if (carFMVItem.value)
                totalValue = parseFloat(carFMVItem.value)

            if (accPriceItem?.value)
                totalValue += parseFloat(accPriceItem.value)
            // Round to two decimal places
            totalValue = parseFloat(totalValue.toFixed(2));
            fieldItem["value"] = totalValue;

           let errorMsg = [VEHICLE_TYPE_MOTORCYCLE, VEHICLE_TYPE_MOTORCYCLE_COMMERCIAL].includes(vehicleType?.value?.value) ? fieldItem?.['error_message'] : ''; 
           fieldItem["error_message"] = errorMsg;
            return totalValue
        }
        if(isCountryId && ['plate_number','color','machine_number','chassis_number'].includes(fieldItem.name)){
            fieldItem['value'] = fieldItem?.value?.toUpperCase();
            return fieldItem.value?.toUpperCase()
        }

        return fieldItem.value || ''
    }
    const isEnable = (fieldItem: any) => {
        if(fieldItem['not_set']) return true

        //if on quote detail page & apptype renewal, then
        //disable following fields
        if (props.formType === 'EDIT' && props.apptype === APP_TYPE_RENEWAL) {
            if (['make', 'model', 'version', 'insurance_exists', 'insurer_name', 'expiration_date', 'make_year', 'vehicle_type'].includes(fieldItem.name)) {
                return false
            }

            //if renewal & vehicle type is not sedan suv, then disable vehicle usage
            if(fieldItem.name === "vehicle_usage") {
                const vehicleType = getFieldItem('vehicle_type')
                const vehicleTypeVal = typeof vehicleType?.value === 'object' ? vehicleType?.value?.value : vehicleType?.value
                if (![1, 2, 6, 7].includes(vehicleTypeVal)) {
                    return false
                }
            }
        }

        if (props.formType === 'EDIT' && fieldItem.name === 'is_rush_delivery') {
            return false;
        }   

        if (fieldItem?.name?.includes('cur_') && isSameAsSelected()) { return false } 
        return fieldItem.is_enable
    }
    
    
    const fetch_mgf_year = async (fieldItem?: any) => {
        let mgf_year= (commonState?.common?.make_year)?commonState.common.make_year:{}
        let makeYearField = getFieldItem('make_year')

        if (makeYearField) {
            const vehicleType = getFieldItem('vehicle_type')
            if ([VEHICLE_TYPE_MOTORCYCLE, VEHICLE_TYPE_MOTORCYCLE_COMMERCIAL].includes(vehicleType?.value?.value) && !isCountryId) {
                makeYearField['options'] = []
                makeYearField['options'] = fieldItem.value.value === INS_TYPE_COMPREHENSIVE ? mgf_year['mgf_bike_comprehensive'] : mgf_year['mgf_bike_ctpl']
            } else {
                makeYearField['options'] = (fieldItem.value.value === INS_TYPE_COMPREHENSIVE) ? mgf_year?.mgf_comprehensive : mgf_year?.mgf_ctpl
                if(isCountryId) makeYearField['options'] = mgf_year;
            }

            //FOR WITHOUT RULE ENGINE SHOW ALL YEARS
            if (+props?.applicationType === WITHOUT_RULE_ENGINE && ![VEHICLE_TYPE_MOTORCYCLE, VEHICLE_TYPE_MOTORCYCLE_COMMERCIAL].includes(vehicleType?.value?.value)) {
               if(!isCountryId){
                    makeYearField['options'] = mgf_year?.without_mfg_comprehensive
               }
                
            }
        }
    }

    const fetchPaymentTerm = (fieldItem?: any) => {
        let pay_term= (commonState?.common?.payment_term)?commonState.common.payment_term:[]
        let payTermField = getFieldItem('payment_term')
        if (payTermField) {
            payTermField['options'] = pay_term
        }
    }
    
    const fetchPaymentTenure = (fieldItem?: any, params?: any) => {
        let isPaymentMethodSelected = props?.fields?.find((fieldItem: any) => fieldItem.name === "payment_method" && (fieldItem.value || params?.payment_method)) //use params payment method if apptype renewal
        if (isPaymentMethodSelected) {
            let payment_tenure = (commonState?.common?.payment_tenure) ? commonState.common.payment_tenure : []
            let payment_method_id = isPaymentMethodSelected.value.value || params?.payment_method
            let paymentTenureField = getFieldItem('payment_tenure')
            if (paymentTenureField) {
                let options = payment_tenure?.filter((el: any) => el.payment_method === payment_method_id && el.payment_term === (fieldItem?.value?.value || params?.payment_term)) //use params payment term if apptype renewal
                paymentTenureField['options'] = options;

                //if apptype renewal, then prefill payment tenure
                if(params?.is_renewal && params?.payment_tenure) {
                    paymentTenureField['value'] = options?.find((tenure: any) => tenure.value === params.payment_tenure)
                    const ptLabel = paymentTenureField['value']
                    const installment = ptLabel?.label?.split(' ')?.[0] || 0
                    setTotalInstallments(installment)
                }

                if ((!options || !options.length) && fieldItem?.value?.label?.trim() === 'One time Payment') paymentTenureField['is_show'] = false;
                else paymentTenureField['is_show'] = true;
            }
        }
    }

    const updateBarangay = (fieldItem: any, response: any, key: string) => {
        if (props.apptype !== APP_TYPE_STANDALONE && response?.data?.data) {
            let is_renewal = props.apptype === APP_TYPE_RENEWAL ? true : false
            let customer_details = !is_renewal ? insuranceState?.activeLoanID?.customer_details : {
                per_city: +insuranceState?.leadDetail?.per_city,
                cur_city: +insuranceState?.leadDetail?.cur_city,
                per_barangay: +insuranceState?.leadDetail?.per_barangay,
                cur_barangay: +insuranceState?.leadDetail?.cur_barangay,
            }
            updateInsuranceForm({ ...customer_details, type: is_renewal ? 'renewal' : false }, fieldItem).then(() => {
                //update redux state for prefilling without clicking next
                props?.saveDetails(props?.sectionItemAll)
            })
        }
    }


    let rowClass = (props.rowClass) ? props.rowClass : "col-md-4";
    let hideField = (props.hideFieldType)? props.hideFieldType:[] 
    
    const expiryDateField = props.fields?.find((item: any) => item.name === "expiry_date");
    const effectivityDateField = props.fields?.find((item: any) => item.name === "effectivity_date");
    const expiryDateValue = expiryDateField?.value;
    let effectivityDateValue = effectivityDateField?.value ? new Date(effectivityDateField.value) : null;

    if (effectivityDateValue) {
        // If time is missing (00:00:00), set the current time
        const now = new Date();
        if (
            effectivityDateValue.getHours() === 0 &&
            effectivityDateValue.getMinutes() === 0 &&
            effectivityDateValue.getSeconds() === 0
        ) {
            effectivityDateValue.setHours(now.getHours(), now.getMinutes(), now.getSeconds());
        }
    }

    const onToggleChange = (fieldItem: any) => {
        fieldItem.value = fieldItem.value === 1 ? 0 : 1;

        fieldItem.error_message = '';

        setRefresh((prev) => prev + 1);

        if (props.onValueChange) {
            props.onValueChange(fieldItem);
        }

    }
    
    
    // Effectivity min / max dates
    const effectivityMinDate = moment().subtract(SUBTRACT_YEAR.SIX, "month").toDate();


    const effectivityMaxDate = moment()
        .add(SUBTRACT_YEAR.ONE, "year")
        .toDate();
    
    const receivedMinDate = moment().subtract(SUBTRACT_YEAR.THREE, "year").toDate()

    const fetchPermanentCity = async (fieldItem?: any, params?: any) => {

        let response = await CommonService.getCityList({ state: [fieldItem.value.value] })
        if (response?.status === STATUS_SUCCESS) {
            if (response?.data?.data) {
                setLocalityList(response.data.data)
            }
        }
        let perCityField = getFieldItem('per_city');
        if (perCityField) {
            perCityField['options'] = response?.data?.data
        }
        if (isSameAsSelected() || params?.per_sameas_cur) {
            let perCityField = getFieldItem('cur_city')
            if (perCityField) {
                perCityField['options'] =response?.data?.data
            }
        }
       
    }

    const fetchCurrentCity = async (fieldItem?: any, params?: any) => {
        let curCityField = getFieldItem('cur_city');
        if (curCityField) {
            let response = await CommonService.getCityList({ state: [fieldItem.value.value] })
            if (response?.status === STATUS_SUCCESS) {
                if (response?.data?.data) {
                    curCityField['options'] = response.data.data;
                    setRefresh((prev) => prev+1);
                }
            }
        }
    }

    return (
        <>
            {
                props?.fields?.map((fieldItem: any, index: number) => {
                    
                    // if app type is UCF then other detail dealer id, select_addon will hide key otherwise select_addon hide 
                    hideField = props?.apptype === APP_TYPE_WITH_UCF ? ['select_addon', 'other_detail_dealer_id', 'paid_by_customer'] : ['select_addon'];
                    hideField = props?.apptype === APP_TYPE_RENEWAL ? [...hideField, 'other_detail_dealer_id'] : hideField

                    const isShowField = isShowDynamicField(fieldItem, hideField);

                    let optionsList = (fieldItem?.options?.length && fieldItem?.name !== 'vehicle_type') ? fieldItem.options : getOptionList(fieldItem);
                    
                    if(isCountryId && fieldItem?.name === 'vehicle_type') optionsList = getOptionList(fieldItem);

                    optionsList = (insuranceState?.leadDetail?.application_type === APP_TYPE_AGENCY && fieldItem?.name === 'vehicle_usage') ? getOptionList(fieldItem) : optionsList
                    
                    let optionValue = typeof fieldItem.value === 'object' ? fieldItem.value : (fieldItem.value != 0 || fieldItem.value === 0) ? optionsList?.filter((option: any) => option.value == fieldItem.value)?.[0] : null;   // eslint-disable-line

                    if(isCountryId && fieldItem?.name === 'insurer_branch_id') {
                        optionsList = getOptionList(fieldItem);
                        const defaultBranch:Record<string,any>=
                        optionsList?.find((option: any) => option.is_hq === IS_HQ);
                        const insurerBranchId = getFieldItem('insurer_branch_id');
                        if (insurerBranchId && optionValue === null) {
                            insurerBranchId['value'] = defaultBranch
                        }
                        optionValue = optionValue === null? defaultBranch: optionValue;
                        
                    }

                    //if edit quote details & renewal
                    if (props.formType === 'EDIT' && props.apptype === APP_TYPE_RENEWAL) {
                        //disable mmv if renewal lead
                        if (['make', 'model', 'version'].includes(fieldItem.name)) {
                            const label = insuranceState?.leadDetail?.[fieldItem.name + '_name']
                            const value = insuranceState?.leadDetail?.[fieldItem.name]
                            fieldItem.value = { label, value }
                            optionValue = fieldItem.value
                        }
                    }

                    let inputType = (['per_postal_code', 'cur_postal_code', 'per_rw', 'per_rt', 'cur_rt', 'cur_rw', 'phone'].includes(fieldItem.name)) ? 'number' : 'text';

                    fieldItem['conditional_manadatory'] = ([2, 3].includes(+props?.apptype) && ['plate_number', 'mv_number'].includes(fieldItem.name)) ? true : false

                    if (fieldItem.name === 'payment_term' && props?.insuranceType === INS_TYPE_CTPL) {
                        optionsList = optionsList?.filter((opt: any) => opt.value !== PAYMENT_TERM_INSTALLMENT)
                    }
                    const fieldValue = getFieldValue(fieldItem) || '';
                    let formattedValue = fieldValue;
                    if(isCountryId){
                        formattedValue = fieldItem.type === FIELD_TYPE.CURRENCY ? HELPER.addCurrencyFormatting(fieldValue) : fieldValue;
                    }
                    // console.log("fieldItem==>",fieldItem,"fieldItem.type==>",fieldItem.type,"isShowField==>",isShowField,"inputType====>",inputType);
                    switch (fieldItem.type) {
                        case FIELD_TYPE.CURRENCY:
                        case FIELD_TYPE.TELEPHONE:
                        case FIELD_TYPE.SUM:
                        case FIELD_TYPE.TEXT_BOX:
                        case FIELD_TYPE.MOBILE_FIELD:
                            return (
                                isShowField &&
                                <fieldset className={rowClass} key={index}>
                                    <div className="material">
                                        {
                                            isEnable(fieldItem) ? 
                                            <input 
                                            maxLength={(fieldItem.type === FIELD_TYPE.MOBILE_FIELD && !isCountryId) ? 10 : DEFAULT_INPUTFIELD_LENGTH} 
                                            disabled={!isEnable(fieldItem)}  
                                            type={inputType} 
                                            spellCheck={false}
                                            placeholder=" " 
                                            name={fieldItem.name} 
                                            className="form-input" 
                                            value={formattedValue} 
                                            onChange={(event) => {
                                                if(isCountryId){
                                                    const inputValue = event.target.value;
                                                    let finalValue: string = inputValue;
                                                    if (fieldItem.type === FIELD_TYPE.CURRENCY) {
                                                        finalValue = String(HELPER.removeCurrencyFormattingId(inputValue));
                                                    }
                                                    onChangeText(fieldItem, finalValue);
                                                }else{
                                                    onChangeText(fieldItem, event.target.value);
                                                }
                                            }}
                                            onKeyDown={inputType === 'number' ? restrictInvalidNumberKeys : undefined}
                                        />
                                        : 
                                        <input 
                                        maxLength={(fieldItem.type === FIELD_TYPE.MOBILE_FIELD && !isCountryId) ? 10 : DEFAULT_INPUTFIELD_LENGTH} 
                                        disabled={!isEnable(fieldItem)}  
                                        type={inputType} 
                                        placeholder=" " 
                                        name={fieldItem.name} 
                                        className="form-input" 
                                        value={formattedValue}  
                                        onKeyDown={inputType === 'number' ? restrictInvalidNumberKeys : undefined}
                                        />
                                        }
                                        {/* if label is email and lead is UCF then email is not mandatory*/}
                                        {(fieldItem.label === 'Email' && +props.apptype === 1) ?
                                            <label data-label={fieldItem.label} className="form-label"></label>
                                            :
                                            <label data-label={fieldItem.label + ((props?.apptype !== APP_TYPE_AGENCY || (props.apptype === APP_TYPE_AGENCY && !['insurer_name'].includes(fieldItem.name))) ? (fieldItem.is_required ? '*' : ((fieldItem?.conditional_manadatory ? '**' : ''))) : '')} className="form-label"></label>
                                        } 
                                        
                                        {fieldItem?.error_message ? <span className="error-txt">{fieldItem.error_message}</span> : null}
                                    </div>
                                </fieldset>
                            )
                        case FIELD_TYPE.FUTURE_DATE:
                            case FIELD_TYPE.DATE_PICKER: {
                                return (
                                    isShowField && fieldItem.name === 'expected_installment'
                                        ? times(totalInstallments, (idx: number) => {
                                            const placeholder = `Expected ${idx + 1}${nthNumber(idx + 1)} Installment`
                                            return (
                                                <React.Fragment key={idx + placeholder}>
                                                    {/* Expected Installment Amount Field */}
                                                    <fieldset className={rowClass} key={'expected_installment_amount' + idx + 1}>
                                                        <div className="material">
                                                            <CurrencyInputField
                                                                inputProps={{
                                                                    id: 'expected' + (idx + 1) + "_amount",
                                                                    type: "text",
                                                                    name: 'expected' + (idx + 1) + "_amount",
                                                                    placeholder: " ",
                                                                    value: fieldItem?.value?.[idx + 1]?.expected_installment_amount || "",
                                                                    className: "form-input",
                                                                    disabled: false,
                                                                }}
                                                                onChange={(event: any) => {
                                                                    onValueSelect(fieldItem, { [idx + 1]: { ...fieldItem?.['value']?.[idx + 1], expected_installment_amount: (removeCurrencyFormatting(event?.target?.value) || 0) } }, { key: 'amount' });
                                                                }}
                                                            />
                                                            <label data-label={placeholder + " Amount*"} className="form-label"></label>
                                                            {
                                                                fieldItem?.error_message?.[idx + 1]?.expected_installment_amount ?
                                                                    <span className="error-txt">
                                                                        {fieldItem.error_message?.[idx + 1].expected_installment_amount}
                                                                    </span>
                                                                    : null
                                                            }
                                                        </div>
                                                    </fieldset>
                            
                                                    {/* Expected Installment Date Field */}
                                                    <fieldset className="form-filed col-md-4" key={fieldItem.name + idx + 1}>
                                                        <div className={"material animation-effect" + (fieldItem?.value?.[idx + 1]?.expected_installment_date ? ' date-label' : '')}>
                                                            <ExpectedInstallmentDate
                                                                onChange={(e: Date) => onValueSelect(fieldItem, { [idx + 1]: { ...fieldItem?.['value']?.[idx + 1], expected_installment_date: e } }, { key: 'date' })}
                                                                selected={fieldItem?.value?.[idx + 1]?.expected_installment_date || ''}
                                                                dateFormat="dd MMM, yyyy"
                                                                disabled={false}
                                                                installmentNumber={idx + 1}
                                                                prevInstallmentDate={fieldItem?.value?.[idx]?.expected_installment_date || null}
                                                                text={placeholder + " Date*"}
                                                            />
                                                            {
                                                                fieldItem?.error_message?.[idx + 1]?.expected_installment_date ?
                                                                    <span className="error-txt">{fieldItem?.error_message?.[idx + 1]?.expected_installment_date}</span>
                                                                    : ''
                                                            }
                                                        </div>
                                                    </fieldset>
                                                </React.Fragment>
                                            )
                                        })
                                        : isShowField &&
                                        <fieldset className={"form-filed date-picker-detail " + rowClass} key={index}>
                                            <div className={"material animation-effect" + (fieldItem.value ? ' active-label' : '')}>
                                                {
                                                    ['effectivity_date', 'expiry_date', 'received_date'].includes(fieldItem.name)
                                                        ? (
                                                            <ExpiryEffectivityDate
                                                                onChange={(e: Date) => onValueSelect(fieldItem, e)}
                                                                placeholder=""
                                                                text={fieldItem.name === "effectivity_date" ? "Insurance Policy Effectivity Date *" 
                                                                        : fieldItem.name === "expiry_date" ? "Insurance Policy Expiry Date *" : `${fieldItem.label} *`
                                                                    }
                                                                insurancePolicyDate={fieldItem?.value}
                                                                flag={fieldItem.name}
                                                                dateFormat="dd/MM/yyyy"
                                                                showTimeSelect={false}
                                                                minDate={fieldItem.name === "effectivity_date" ? effectivityMinDate : fieldItem.name === "expiry_date" ? new Date(minExpiryDate) : receivedMinDate}
                                                                maxDate={fieldItem.name === "effectivity_date" && expiryDateValue && !effectivityDateValue && 
                                                                    moment(expiryDateValue).startOf('day').diff(moment().startOf('day').toDate(), 'days') < EFFECTIVITY_EXPIRY_INTERVAL
                                                                    ? new Date(0) 
                                                                    : fieldItem.name === "effectivity_date"
                                                                    ? effectivityMaxDate
                                                                    : fieldItem.name === "expiry_date"
                                                                    ? maxExpiryDate
                                                                    : fieldItem.name === "received_date" 
                                                                    ? new Date()
                                                                    : undefined
                                                                } 
                                                                {...(fieldItem.name === "expiry_date" ? { effectivity_date: effectivityDateValue || new Date() } : {})}
                                                                openToDate={fieldItem.name === "expiry_date" ? new Date(minExpiryDate): new Date()}
                                                            />
                                                        ) : (
                                                            <Calendra2
                                                                onChange={(e: Date) => onValueSelect(fieldItem, e)}
                                                                placeholder={fieldItem.label + ((props?.apptype !== APP_TYPE_AGENCY || (props.apptype === APP_TYPE_AGENCY && !['expiration_date'].includes(fieldItem.name))) ? (fieldItem.is_required ? '*' : '') : '')}
                                                                dateFormat="dd/MM/yyyy"
                                                                selected={fieldItem?.value}
                                                                fieldId={fieldItem.id}
                                                                fields={props?.fields}
                                                                fieldLabel={fieldItem.label}
                                                                disabled={(props.apptype === APP_TYPE_RENEWAL && props.formType === 'EDIT') ? true : !fieldItem.is_enable}
                                                                apptype={props.apptype}
                                                                fieldname={fieldItem.name}
                                                            />
                                                        )
                                                }
                                                {fieldItem?.error_message ? <span className="error-txt">{fieldItem.error_message}</span> : null}
                                            </div>
                                        </fieldset>
                                )
                            }
                            
                        case FIELD_TYPE.DATE_TIME: {
                            return (
                                isShowField &&
                                <fieldset className={"form-filed date-picker-detail " + rowClass} key={index}>
                                    <div className={"material animation-effect" + (fieldItem.value ? ' active-label' : '')}>
                                        <ExpiryEffectivityDate
                                            onChange={(e: Date) => onValueSelect(fieldItem, e)}
                                            placeholder=""
                                            text={fieldItem.label}
                                            insurancePolicyDate={fieldItem?.value}
                                            flag = {fieldItem.name}
                                        />
                                        {fieldItem?.error_message ? <span className="error-txt">{fieldItem.error_message}</span> : null}
                                    </div>

                                </fieldset>
                            )
                        }
                        case FIELD_TYPE.CHECK_BOX:
                            return (
                                <div className="form-filed col-md-11  m-xs-b " key={index}>
                                    <div className="material">
                                        <div className="custom-control custom-checkbox">
                                            <input checked={fieldItem.value} id="Individual" type="checkbox" className="custom-control-input " name="Buyer Type" onChange={(e) => {
                                                onChangeCheckbox(fieldItem)
                                            }} disabled={!fieldItem.is_enable}/>
                                            <label className="custom-control-label">Same as Permanent Address </label>
                                        </div>

                                    </div>
                                </div>
                            )
                        case FIELD_TYPE.TEXT_AREA:
                            return (
                                <fieldset className="form-filed col-md-4">
                                    <div className={"material"}>
                                        <textarea id="description" placeholder=" " name="notes" className="form-input" value={fieldItem.value} onChange={(e) => onValueSelect(fieldItem, e.target.value)} />
                                        <label data-label={fieldItem.label} className="form-label"></label>
                                    </div>
                                </fieldset>
                            )
                        
                        case FIELD_TYPE.MULTI_DROP_DOWN:
                            return (                               
                                <fieldset className="multiselect-dropDown col-md-4">
                                <div className={ ((fieldItem.name === 'other_doc' &&  fieldItem.value.length >0 )|| typedValue) ? "active-label material animation-effect" : "material animation-effect "}>
                                    <MultiSelect
                                        id="other_docs"
                                        key={"other_docs"}
                                        options={optionsList || []}
                                        value={optionValue ?? []} 
                                        onChange={(e: any) => onValueSelect(fieldItem, e)}
                                        isSelectAll={true}
                                        placeholder={""}
                                        setTypedValue = {setTypedValue}
                                    />
                                    <label data-label={fieldItem.label} className="form-label"></label>
        
                                </div>
                            </fieldset>
                            )
                            
                        case FIELD_TYPE.SWITCH:
                            return (
                                props.apptype !== APP_TYPE_RENEWAL && isEnable(fieldItem) &&
                                <fieldset className="form-filed">
                                        <div className="material status-btn toggle-rush">
                                            <div className="status-txt m-sm-r">{fieldItem.label}</div>
                                            <div className='toggle-btn'>
                                                <ToggleSwitch
                                                    checked={fieldItem.value === 1}
                                                    onChange={() => onToggleChange(fieldItem)}
                                                />
                                            </div>

                                        </div>
                                </fieldset>
                            )
                    

                        case FIELD_TYPE.RADIO_BOX:
                           
                            return (
                                isShowField &&
                                <fieldset className={"form-filed " + rowClass} key={index}>
                                    <div className="material">
                                        <label className="radio-label-heading">
                                            {fieldItem.label + (fieldItem.is_required ? '*' : '')}
                                        </label>
                                        {
                                            fieldItem?.name === 'insurance_type'
                                            ? times(getSelectedTenureCount() || 1, (tenureIdx: number) => (
                                                <div className="custom-radio-group radio-btn insurance-type-inline p-md-t" key={`${fieldItem.name}_tenure_${tenureIdx + 1}`}>
                                                    <label className="radio-label">{`${tenureIdx + 1}${nthNumber(tenureIdx + 1)} Year`}</label>
                                                    {(optionsList || []).map((option: any) => (
                                                        <label className="custom-control custom-checkbox" key={`${fieldItem.name}_${tenureIdx + 1}_${option.value}`}>
                                                            <input
                                                                type="radio"
                                                                className="custom-control-input"
                                                                name={`${fieldItem.name}_${tenureIdx + 1}`}
                                                                checked={Number(getInsuranceTypeSelections(fieldItem)?.[tenureIdx]) === Number(option.value)}
                                                                disabled={!isEnable(fieldItem) || hasPreviousTloSelection(fieldItem, tenureIdx)}
                                                                onChange={() => onValueSelect(fieldItem, option, { tenureIdx })}
                                                            />
                                                            <span className="custom-control-label">{option.label}</span>
                                                        </label>
                                                    ))}
                                                </div>
                                            ))
                                            : <div className="custom-radio-group radio-btn">
                                                {(optionsList || []).map((option: any) => (
                                                    <label className="custom-control custom-checkbox" key={`${fieldItem.name}_${option.value}`}>
                                                        <input
                                                            type="radio"
                                                            className="custom-control-input"
                                                            name={fieldItem.name}
                                                            checked={optionValue?.value === option.value}
                                                            disabled={!isEnable(fieldItem)}
                                                            onChange={() => onValueSelect(fieldItem, option)}
                                                        />
                                                        <span className="custom-control-label">{option.label}</span>
                                                    </label>
                                                ))}
                                            </div>
                                        }
                                        {fieldItem?.name === 'insurance_type' && getSelectedTenureCount() > 1 && (
                                            <div className="p-lg-t insurance-type-info">
                                                <i className="ic-info-icon1 m-sm-r"></i>
                                                <span> {translations?.MULTI_TENURE?.TLO_SELECTED}</span>
                                            </div>
                                        )}
                                        {fieldItem?.error_message ? <span className="error-txt">{fieldItem.error_message}</span> : null}
                                    </div>
                                </fieldset>
                            )
                        default: {
                            return (
                                
                                isShowField && 
                                <React.Fragment key={index} >
                                    {
                                        isEnable(fieldItem) ? 
                                        <ReactSelect 
                                        options={optionsList} 
                                        value={optionValue} 
                                        handleChange={(e: any) => onValueSelect(fieldItem, e)} 
                                        placeholder={fieldItem.label + ((fieldItem.is_required && (props?.apptype !== APP_TYPE_AGENCY || (props.apptype === APP_TYPE_AGENCY && !['insurer_name', 'expiration_date', 'financier'].includes(fieldItem.name))) && (fieldItem.name !=="copy_of_insurance" || (fieldItem.name === 'copy_of_insurance' && props.apptype === APP_TYPE_WITH_UCF || isCountryId))) ? '*' : '')} 
                                        fieldKey="" 
                                        fieldItemName={fieldItem.name} 
                                        isDisabled={!isEnable(fieldItem)} 
                                        errorField={fieldItem?.error_message}
                                        fieldSetClassName={"form-filed " + rowClass}
                                        note={fieldItem?.note ||""}
                                    />
                                        :
                                        <ReactSelect 
                                        options={optionsList} 
                                        value={optionValue} 
                                        placeholder={fieldItem.label + ((fieldItem.is_required && (fieldItem.name !=="copy_of_insurance" || (fieldItem.name === 'copy_of_insurance' && (props.apptype === APP_TYPE_WITH_UCF || isCountryId)))) ? '*' : '')} 
                                        fieldKey="" 
                                        isDisabled={!isEnable(fieldItem)} 
                                        errorField={fieldItem?.error_message}
                                        fieldSetClassName={"form-filed " + rowClass}
                                    /> 
                                    }
                                   
                                </React.Fragment>
                            )
                        }
                    }
                })
            }
        </>
    )
}

export default DynamicFormField
